import Button from "@mui/material/Button";
import { useAppStore, type Language } from "../../shared/store/app";
import { useT } from "../../shared/i18n";

export function LanguageToggle() {
  const t = useT();
  const language = useAppStore((s) => s.language);
  const setLanguage = useAppStore((s) => s.setLanguage);
  const next: Language = language === "en" ? "de" : "en";
  const target = next === "de" ? "Deutsch" : "English";
  return (
    <Button
      size="small"
      variant="text"
      color="inherit"
      onClick={() => setLanguage(next)}
      aria-label={t("switchLanguage", { language: target })}
    >
      {language === "en" ? "DE" : "EN"}
    </Button>
  );
}